// extracted by mini-css-extract-plugin
export default {"diamonds":"style_diamonds__c22iS","inline":"style_inline__BQaUx","diamond-icon":"style_diamond-icon__1Hw1Q"};